export const CLEAR_TRAFFIC_TEMPLATE_MANAGER_PAGE =
  "CLEAR_TRAFFIC_TEMPLATE_MANAGER_PAGE";

export const OPEN_MANAGE_TRAFFIC_TEMPLATE_DIALOG =
  "OPEN_MANAGE_TRAFFIC_TEMPLATE_DIALOG";

export const CLOSE_MANAGE_TRAFFIC_TEMPLATE_DIALOG =
  "CLOSE_MANAGE_TRAFFIC_TEMPLATE_DIALOG";
